/**
 * search.js — Predictive search overlay for the amphr Shopify theme.
 * Loaded with defer from layout/theme.liquid (after amphr.js).
 *
 * - Focuses the search input when the overlay opens.
 * - Debounced (250 ms) fetch from Shopify Predictive Search API via Section Rendering.
 * - Chip buttons fill the input and trigger a live search.
 * - The <form> still submits natively on Enter for full search results.
 */

(function () {
  'use strict';

  /* ─── Element references ─────────────────────────────────────────────────── */
  var overlay  = document.getElementById('amphr-search');
  var input    = document.getElementById('amphr-search-input');
  var results  = document.getElementById('amphr-search-results');

  if (!overlay || !input || !results) return;

  var SKELETON_COUNT = 4;
  /* Numarul de carduri din ultimul raspuns randat; ramane SKELETON_COUNT pentru prima interogare a sesiunii
     si pentru cea care urmeaza uneia cu 0 rezultate (0 carduri anterioare nu e o estimare, e "nimic de aratat"). */
  var lastResultCount = null;

  /* ─── Debounce helper ────────────────────────────────────────────────────── */
  function debounce(fn, ms) {
    var timer;
    return function () {
      var args = arguments;
      var ctx  = this;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  /* ─── Fetch & inject predictive results ─────────────────────────────────── */
  function fetchResults(q) {
    if (!q || q.length < 2) {
      results.innerHTML = '';
      results.removeAttribute('aria-busy');
      return;
    }

    var url =
      ((window.routes && window.routes.predictive_search_url) || '/search/suggest') +
      '?q=' +
      encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&section_id=amphr-predictive-search';

    /* Garda impiedica doar schelet-peste-schelet (un fetch in zbor cand altul
       tocmai a intrat in aceeasi stare), nu inlocuirea rezultatelor valide:
       daca .card--sk nu e in DOM pentru ca rezultatele reale sunt deja
       afisate, conditia tot intra si le suprascrie la urmatoarea tasta —
       exact ce se intampla oricum, fetch-ul care urmeaza le inlocuieste. Randul
       .srescount e reprodus si el (gol) fiindca raspunsul real il pune
       inaintea grilei — fara el grila scheletului porneste mai sus decat
       grila reala, si cardurile nu s-ar suprapune. */
    if (!results.querySelector('.card--sk') && window.amphrSkeleton) {
      var skeletonCount = (lastResultCount === null || lastResultCount === 0) ? SKELETON_COUNT : lastResultCount;
      results.setAttribute('aria-busy', 'true');
      results.innerHTML = '<p class="srescount" aria-hidden="true">&nbsp;</p><div class="grid sgrid">' +
        window.amphrSkeleton.productCard(skeletonCount) + '</div>';
    }

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Search request failed: ' + res.status);
        return res.text();
      })
      .then(function (html) {
        /* Guard against out-of-order responses: only render if the query
           still matches what the user has typed. */
        if (input && input.value.trim() !== q) return;
        /* Section Rendering wraps the section output in a <div id="shopify-section-*">.
           Extract just the inner HTML so we don't nest extra wrappers. */
        var parser   = new DOMParser();
        var doc      = parser.parseFromString(html, 'text/html');
        var section  = doc.querySelector('[id^="shopify-section-"]');
        /* Safe: response is from Shopify's own Section Rendering API (same-origin
           server-rendered Liquid). It is not user-controlled input. */
        results.innerHTML = section ? section.innerHTML : html;
        results.removeAttribute('aria-busy');
        lastResultCount = results.querySelectorAll('.sgrid > .card').length;
      })
      .catch(function (err) {
        /* Fail silently — the form submit still works as the fallback. */
        console.warn('[amphr search]', err);
        results.removeAttribute('aria-busy');
      });
  }

  var debouncedFetch = debounce(fetchResults, 250);

  /* ─── Input handler ──────────────────────────────────────────────────────── */
  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (q.length >= 2) {
      debouncedFetch(q);
    } else {
      results.innerHTML = '';
      results.removeAttribute('aria-busy');
    }
  });

  /* ─── Chip click: fill input + trigger search ────────────────────────────── */
  overlay.addEventListener('click', function (e) {
    var chip = e.target.closest('.schip');
    if (!chip) return;
    var text = chip.textContent.trim();
    input.value = text;
    fetchResults(text);
    input.focus();
  });

  /* ─── Focus input when overlay opens ────────────────────────────────────── */

  /* Strategy 1: MutationObserver watches for .on being added to the overlay. */
  var mo = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (
        m.type === 'attributes' &&
        m.attributeName === 'class' &&
        overlay.classList.contains('on')
      ) {
        /* Small delay lets the CSS transition start so the input is visible. */
        setTimeout(function () { input.focus(); }, 60);
      }
    });
  });
  mo.observe(overlay, { attributes: true });

  /* Strategy 2: Listen for clicks on search-open triggers as a quick backup. */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open="#amphr-search"]');
    if (!opener) return;
    setTimeout(function () { input.focus(); }, 80);
  });

})();
